import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import t from "@/lang/lang";
import {
  Company,
  useListCompanyQuery,
} from "@/services/backend/company/api/company";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { CompanyCreateDialog } from "@/services/backend/company/components/company-create-dialog";
import { DeleteCompanyDialog } from "@/routes/base-data/companies/list/_components/delete-company-dialog";
import { Card } from "@/shared/components/ui/card";
import { TableCard } from "@/shared/components/tables/table-card";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageDescription,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import { NavLink, useNavigate } from "react-router";

export function CompanyListRoute() {
  const navigate = useNavigate();

  return (
    <BaseDataPage>
      <BaseDataPageHeader>
        <BaseDataPageTitle>
          <span>{t("Unternehmen")}</span>
          <CompanyCreateDialog
            onCreated={(companyId) =>
              navigate(`/base-data/companies/${companyId}`)
            }
          />
        </BaseDataPageTitle>
        <BaseDataPageDescription>
          {t("Ein Unternehmen ist ein Unternehmen der GESA Gruppe.")}
        </BaseDataPageDescription>
      </BaseDataPageHeader>
      <BaseDataPageContent>
        <CompanyList />
      </BaseDataPageContent>
    </BaseDataPage>
  );
}

function CompanyList() {
  const { data: list, isLoading, error } = useListCompanyQuery({});

  if (isLoading) {
    return <Skeleton />;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <TableCard>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-full">{t("Unternehmen")}</TableHead>
            <TableHead>{t("Kurzform")}</TableHead>
            <TableHead>{t("Aktionen")}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {list?.companies.map((company) => (
            <CompanyTableRow key={company.id} company={company} />
          ))}
        </TableBody>
      </Table>
    </TableCard>
  );
}

function CompanyTableRow({ company }: { company: Company }) {
  return (
    <TableRow>
      <TableCell>
        <NavLink
          to={`/base-data/companies/${company.id}`}
          className="hover:underline"
        >
          {company.name}
        </NavLink>
      </TableCell>
      <TableCell>{company.shortName}</TableCell>
      <TableCell className="flex space-x-2">
        <DeleteCompanyDialog company={company} />
      </TableCell>
    </TableRow>
  );
}

function Skeleton() {
  return (
    <Card>
      <Table className="animate-pulse">
        <TableHeader>
          <TableRow>
            <TableHead className="w-full">{t("Unternehmen")}</TableHead>
            <TableHead>{t("Kurzform")}</TableHead>
            <TableHead>{t("Aktionen")}</TableHead>
          </TableRow>
        </TableHeader>
      </Table>
    </Card>
  );
}
